import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FormResponseErrorType, FormUtils, useFormContext } from '../../../molecules/Form';
import FormsRow from '../../../molecules/Form/components/FormsRow/FormsRow';
import LiveRegion from '../../../atoms/LiveRegion/LiveRegion';
import FormTextarea from '../../../molecules/Form/components/FormTextarea/FormTextarea';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import useRedirect from '../../../../hooks/useRedirect';
import { Views } from '../../../organisms/BlockInteractions';
import { translatePartOfStringWithLink } from '../../../../lib/StringUtils/StringHTMLUtils';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { FormSubmitButton } from '../../../molecules/Form/components/FormSubmitButton/FormSubmitButton';

export function RequestActivityFormTemplate({ translationNamespace, readRestricted = false }) {
  const { status, inputs, onChange, getStatus, responseUrl } = useFormContext();
  const [startRedirect] = useRedirect();
  const { t } = useTranslation();

  const { portalConfiguration } = useAppContext();
  const email = portalConfiguration?.son_portal_support_email
    ? `mailto:${portalConfiguration.son_portal_support_email}`
    : null;

  const getStatusMessage = () => {
    if (
      readRestricted &&
      (translationNamespace.endsWith(Views.ACCEPT_ACTIVATION) || translationNamespace.endsWith(Views.REJECT_ACTIVATION))
    ) {
      return FormUtils.createStatusMessage(t(`${translationNamespace}:status.successReadRestricted`));
    }
    return FormUtils.createStatusMessage(t(`${translationNamespace}:status.success`));
  };

  const statusMessages = {
    [InteractionStatus.SUCCESS]: getStatusMessage(),
    [FormResponseErrorType.NO_TEAMROOM_APPROVER_FOUND]: FormUtils.createStatusMessage(
      translatePartOfStringWithLink(
        `${translationNamespace}.status.${FormResponseErrorType.NO_TEAMROOM_APPROVER_FOUND}`,
        email,
      ),
    ),
  };

  useEffect(() => {
    if (status === InteractionStatus.SUCCESS && readRestricted) {
      startRedirect(responseUrl);
    }
  }, [responseUrl, startRedirect, status, readRestricted]);

  return (
    <>
      <FormsRow>
        <FormTextarea
          type={inputs.reason.type}
          id="invite-unregistered"
          name={inputs.reason.name}
          value={inputs.reason.value}
          labelTitle={t(`${translationNamespace}:labelTitle`)}
          required={inputs.reason.required}
          onChange={event => onChange(inputs.reason.name, event.target.value)}
          maxLength={inputs.reason.constraints.maxLength}
        />
      </FormsRow>
      <FormSubmitButton buttonLabel={t(`${translationNamespace}:text`)} enabled />
      <LiveRegion invisible={false} htmlTag="div">
        {getStatus(statusMessages)}
      </LiveRegion>
    </>
  );
}

RequestActivityFormTemplate.propTypes = {
  translationNamespace: PropTypes.string.isRequired,
  readRestricted: PropTypes.bool,
};
